import { defineMessages } from 'react-intl';

const _default_1: {
	copy: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	copied: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	copiedToClipboard: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	copy: {
		id: 'fabric.editor.ai.config.item.action.copyResponse',
		defaultMessage: 'Copy',
		description: 'Copy the response to the clipboard',
	},
	copied: {
		id: 'fabric.editor.ai.config.item.action.responseCopied',
		defaultMessage: 'Copied!',
		description: 'Copied the response to the clipboard',
	},
	copiedToClipboard: {
		id: 'fabric.editor.ai.config.item.action.responseCopiedToClipboard',
		defaultMessage: 'Copied to clipboard',
		description: 'Copied the response to the clipboard',
	},
});
export default _default_1;
